import LegalGroupPage from "./LegalGroupPage";

export default LegalGroupPage